import { resolveBaseUrl } from '@/shared/lib/api';

/**
 * Call `POST /auth/refresh` with the current bearer to mint a fresh token
 * with an extended expiry. Returns the new token on success, `null` when the
 * server refuses (current bearer expired / invalid / route returns non-2xx).
 *
 * The WS driver invokes this on a 1008/4401 close so a session that nearly
 * expired during a long active play can keep going without bouncing the
 * user back to the login screen. Failures are swallowed: the caller treats
 * `null` as "session is gone, surface unauthorized".
 */
export const refreshAuthToken = async (
  currentToken: string,
  baseUrl: string = resolveBaseUrl(),
): Promise<string | null> => {
  try {
    const res = await fetch(`${baseUrl.replace(/\/$/, '')}/auth/refresh`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${currentToken}`,
      },
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { token?: unknown };
    if (typeof body.token !== 'string' || body.token.length === 0) return null;
    return body.token;
  } catch {
    return null;
  }
};
